export const getRegExpPropWithValue = (entity) => new RegExp(`"${entity}":\\s*"([^"]+)"`, 'gm');
export const UUID_REGEXP = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
